import axios from 'axios';

import { endPoint } from './api';

const axiosInstance = axios.create({
  baseURL: endPoint
});

axiosInstance.interceptors.request.use((config) => {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.common['authorization'] = token;
  return config;
});

export default axiosInstance;
